module.exports = __webpack_public_path__ + "static/media/skater7.3618361e.jpeg";